import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    cd: 0
  }

  @action async getCd(mid) {
    let d = await http.post('/web/rechargeReward/countdown', {})
    this.data.cd = d && d.res
    console.log(d)
  }
}



// WEBPACK FOOTER //
// src/store/app/rechargebonus.js